import {
  Income,
  ServerIncomeFetch,
  ClearIncomeErrorAction,
  CreateIncomeAction,
  CreateIncomeAbortAction,
  CreateIncomeFailAction,
  CreateIncomeSuccessAction,
  DeleteIncomeAction,
  DeleteIncomeFailAction,
  DeleteIncomeSuccessAction,
  FetchIncomesAction,
  FetchIncomesFailAction,
  FetchIncomesSuccessAction,
  SetIncomeErrorAction,
  UpdateIncomeAction,
  UpdateIncomeFailAction,
  UpdateIncomeAbortAction,
  UpdateIncomeSuccessAction,
  UpsertIncomesAction,
  UpsertIncomesFailAction,
  UpsertIncomesSuccessAction,
} from '@funnels/types';
import { REDUX_STORE } from '@funnels/constants';

export function clearIncomeError(): ClearIncomeErrorAction {
  return { type: REDUX_STORE.INCOMES.ACTION_TYPES.CLEAR_INCOME_ERROR };
}

export function createIncome(applicationId: string, income: Income): CreateIncomeAction {
  return { type: REDUX_STORE.INCOMES.ACTION_TYPES.CREATE_INCOME, applicationId, income };
}

export function createIncomeFail(clientId: string): CreateIncomeFailAction {
  return { type: REDUX_STORE.INCOMES.ACTION_TYPES.CREATE_INCOME_FAIL, clientId };
}

export function createIncomeSuccess(clientId: string, id: string): CreateIncomeSuccessAction {
  return { type: REDUX_STORE.INCOMES.ACTION_TYPES.CREATE_INCOME_SUCCESS, clientId, id };
}

export function deleteIncome(applicationId: string, clientId: string, id?: string): DeleteIncomeAction {
  return { type: REDUX_STORE.INCOMES.ACTION_TYPES.DELETE_INCOME, applicationId, clientId, id };
}

export function deleteIncomeFail(clientId: string): DeleteIncomeFailAction {
  return { type: REDUX_STORE.INCOMES.ACTION_TYPES.DELETE_INCOME_FAIL, clientId };
}

export function deleteIncomeSuccess(): DeleteIncomeSuccessAction {
  return { type: REDUX_STORE.INCOMES.ACTION_TYPES.DELETE_INCOME_SUCCESS };
}

export function fetchIncomes(applicationId: string): FetchIncomesAction {
  return { type: REDUX_STORE.INCOMES.ACTION_TYPES.FETCH_INCOMES, applicationId };
}

export function fetchIncomesFail(): FetchIncomesFailAction {
  return { type: REDUX_STORE.INCOMES.ACTION_TYPES.FETCH_INCOMES_FAIL };
}

export function fetchIncomesSuccess(incomes: ServerIncomeFetch[]): FetchIncomesSuccessAction {
  return { type: REDUX_STORE.INCOMES.ACTION_TYPES.FETCH_INCOMES_SUCCESS, incomes };
}

export function setIncomeError(message: string = 'Unknown error'): SetIncomeErrorAction {
  return { type: REDUX_STORE.INCOMES.ACTION_TYPES.SET_INCOME_ERROR, message };
}

export function updateIncome(applicationId: string, income: Income): UpdateIncomeAction {
  return { type: REDUX_STORE.INCOMES.ACTION_TYPES.UPDATE_INCOME, applicationId, income };
}

export function updateIncomeFail(clientId: string): UpdateIncomeFailAction {
  return { type: REDUX_STORE.INCOMES.ACTION_TYPES.UPDATE_INCOME_FAIL, clientId };
}

export function createIncomeAbort(): CreateIncomeAbortAction {
  return { type: REDUX_STORE.INCOMES.ACTION_TYPES.CREATE_INCOME_ABORT };
}

export function updateIncomeAbort(): UpdateIncomeAbortAction {
  return { type: REDUX_STORE.INCOMES.ACTION_TYPES.UPDATE_INCOME_ABORT };
}

export function updateIncomeSuccess(): UpdateIncomeSuccessAction {
  return { type: REDUX_STORE.INCOMES.ACTION_TYPES.UPDATE_INCOME_SUCCESS };
}

export function upsertIncomes(applicationId: string, incomes: Income[]): UpsertIncomesAction {
  return { type: REDUX_STORE.INCOMES.ACTION_TYPES.UPSERT_INCOMES, applicationId, incomes };
}

export function upsertIncomesFail(): UpsertIncomesFailAction {
  return { type: REDUX_STORE.INCOMES.ACTION_TYPES.UPSERT_INCOMES_FAIL };
}

export function upsertIncomesSuccess(): UpsertIncomesSuccessAction {
  return { type: REDUX_STORE.INCOMES.ACTION_TYPES.UPSERT_INCOMES_SUCCESS };
}
